import React from 'react';
import { Box, Heading, VStack, Text, Link, Image } from '@chakra-ui/react';

const Projects = ({ projects, bg, color }) => {
    return (
        <Box id="projects" p={5} bg={bg} borderRadius="lg" boxShadow="md">
            <Heading as="h2" size="lg" color={color}>
                Projects
            </Heading>
            <VStack align="start" mt={4} spacing={4}>
                {projects.map((project, index) => (
                    <Box key={index}>
                        <Heading as="h3" size="md" color={color}>
                            {project.title}
                        </Heading>
                        <Text color={color}>{project.description}</Text>
                        {project.technologies && (
                            <Text color="gray.500" fontSize="sm">
                                Technologies: {project.technologies.join(', ')}
                            </Text>
                        )}
                        {project.previewGif && (
                            <Image
                                objectFit="cover" 
                                borderRadius="lg"
                                margin='auto'
                                boxShadow={'md'}
                                src={project.previewGif}
                                alt={`${project.title} Preview`}
                                fallbackSrc="https://via.placeholder.com/200x200?text=Project+Preview"
                            />
                        )}
                        {project.liveUrl && (
                            <Link href={project.liveUrl} color="teal.500" isExternal>
                                Live Application
                            </Link>
                        )}
                        {(project.frontendUrl || project.backendUrl) && (
                            <VStack spacing={1}>
                                {project.frontendUrl && (
                                    <Link href={project.frontendUrl} color="teal.500" isExternal>
                                        Frontend on GitHub
                                    </Link>
                                )}
                                {project.backendUrl && (
                                    <Link href={project.backendUrl} color="teal.500" isExternal>
                                        Backend on GitHub
                                    </Link>
                                )}
                            </VStack>
                        )}
                    </Box>
                ))}
            </VStack>
        </Box>
    );
};

export default Projects;
